import ForgotPasswordPage from "./forgot-password";
export default ForgotPasswordPage;
